<template>
  <el-row :gutter="20" v-if="event">
    <el-col :span="6" :xs="24" class="cover-column" v-if="event.coverurl">
      <img :src="event.coverurl" alt="活动封面" class="event-cover">
    </el-col>
    
    <el-col :span="18" :xs="24" class="info-column">
      <div class="event-info">
        <h5 class="event-title">{{ event.fullname }}</h5>
        <div><span class="info-label">报名截止时间:</span> {{ formatTimestampToDate(event.starttime) }}</div>
        <div><span class="info-label">结项时间:</span> {{ formatTimestampToDate(event.closetime) }}</div>
        <div class="mt-2">
          <el-tag size="small" v-if="status === 0">
            <span v-if="ticket?.id && orderpaystatus < 99 && orderpaystatus !== 50">报名信息已提交，待付款</span>
            <span v-else>报名信息已提交，待审核</span>
          </el-tag>
          <el-tag size="small" v-if="status === -90" type="danger">已拒绝</el-tag>
          <el-tag size="small" v-else-if="status === 1" type="success">报名审核通过</el-tag>
          <el-tag size="small" v-else-if="status === 2">二期材料已提交，待审核</el-tag>
          <el-tag size="small" v-else-if="status === 3" type="success">二期材料审核通过</el-tag>
          <el-tag size="small" v-else-if="status === 4">结项材料已提交，待审核</el-tag>
          <el-tag size="small" v-else-if="status === 5" type="success">结项审核通过</el-tag>
          <el-tag size="small" v-else-if="status === 100">已结项</el-tag>
        </div>
      </div>
    </el-col>
  </el-row>
</template>

<script>
import { formatTimestampToDate } from '@/utils/dateUtil';
export default {
  props: {
    event: {
      type: Object,
      required: true
    },
    ticket: {
      type: Object,
      default: () => ({})
    },
    status: {
      type: Number,
      default: undefined
    },
    orderpaystatus: {
      type: Number,
      default: undefined
    }
  },
  methods: {
    formatTimestampToDate
  }
}
</script>

<style scoped>
.event-cover {
  max-width: 100%;
  height: auto;
  border-radius: 5px;
}

.event-title {
  font-size: 1.18rem;
  margin-bottom: 10px;
}

.info-label {
  color: #333333;
  margin-right: 5px;
}

@media (max-width: 767px) {
  .cover-column {
    margin-bottom: 20px;
  }
}
</style>
